import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getTokenPayload, saveToken } from "../../token/token";

function OAuth2RedirectHandler() {
  const [searchParams] = useSearchParams();

  // useEffect(() => {
  //     console.log(searchParams.get("token"));
  //     sessionStorage.setItem("token", searchParams.get("accesstoken"));

  //     dispatch(getQuiz());
  //   }, [searchParams]);

  const token = searchParams.get("token");

  if (token) {
    saveToken(token);
    const tokenPayload = getTokenPayload("token");
    window.sessionStorage.removeItem("hasCompanyVerified");
    const isSellerLikeRole = ["SELLER", "STAFF"].includes(
      tokenPayload?.role
    );
    window.location =
      isSellerLikeRole && Boolean(tokenPayload?.isNewUser)
        ? "/admin/home"
        : "/admin/dashboard";
  } else {
    return (
      <Navigate
        to={{
          pathname: "/",
        }}
      />
    );
  }
}

export default OAuth2RedirectHandler;
